import { gql } from "@apollo/client";
import { graphQlClient } from "lib/graphql-client.js";
import React, {
  useContext,
  useEffect,
  // useCallback,
  useMemo,
  useRef,
  useState,
} from "react";

// import { useRouter } from "next/router";
import dynamic from "next/dynamic";

import useWindowSize from "../../../lib/hooks/useWindowSize";
// import { gql } from "@apollo/client";

// import HeroSlider from "components/HeroSlider/HeroSlider";
import MainSlider from "@/components/Slider/BlazeSlider/BlazeSlider";

import Layout from "components/Layout";
import AccordionItem from "components/ui/Accordion/AccordionItem";
const Accordion = dynamic(() => import("components/ui/Accordion/Accordion"));
const ScrollNav = dynamic(
  () => import("components/ui/nav/ScrollNav/ScrollNav")
);
const Intro = dynamic(() => import("components/DestinationPage/Intro"));
const KeyFacts = dynamic(() => import("components/DestinationPage/KeyFacts"));
// const EntryRequirements = dynamic(() =>
//   import("components/DestinationPage/EntryRequirements/EntryRequirements")
// );
import InformationSection from "components/content/InformationSection/InformationSection";
import RelatedExperiences from "/components/ExperiencePresentation/RelatedExperiences/RelatedExperiences";
const RelatedStories = dynamic(
  () => import("/components/BlogPage/RelatedStories")
);
const CurrencyConverter = dynamic(
  () =>
    import("@/components/widgets/currency/CurrencyConverter/CurrencyConverter")
);

const BasicWeatherWidget = dynamic(
  () =>
    import("@/components/widgets/weather/BasicWeatherWidget/BasicWeatherWidget")
);

import { BiMoney } from "react-icons/bi";
import { CiBowlNoodles } from "react-icons/ci";
import { MdOutlineTrain } from "react-icons/md";
import { RiHotelFill } from "react-icons/ri";
import { WiDayCloudyGusts } from "react-icons/wi";

import { site } from "config";
import { CurrencyContext } from "contexts/currency";
import { fetchAffiliatesByDestination } from "lib/api/strapi-affiliates.js";
import { fetchDestination } from "lib/api/strapi-destinations.js";
import { fetchLayoutDataServer } from "lib/api/strapi-layout";
import { covidInfo } from "lib/data/covid-info";
import { GiTreasureMap } from "react-icons/gi";

import { processDestinationData } from "lib/api/strapi-destinations.js";
import { generateBlazeSlides } from "utils/sliders";
import styles from "./destinationSlug.module.scss";

import CardRow from "@/components/card/CardRow";
import ActivitiesSection from "@/components/DestinationPage/ActivitiesSection/ActivitiesSection";
import FoodGuideCards from "@/components/FoodGuides/FoodGuideCards";
import TravelGuideCard from "@/components/guide/components/TravelGuideCard";
import { processExperienceData } from "lib/api/strapi-experiences";
import { processStoryData } from "lib/api/strapi-stories";
import { fetchTravelGuidesByDestination } from "lib/api/strapi-travel-guide";
import { fetchYouTubeData } from "utils/video";

const Country = ({
  destination,
  redirect,
  affiliates,
  covidInfo,
  iVisaInfo,
  layoutData,
  relatedStories,
  relatedExperiences,
  travelGuides,
  foodGuide,
}) => {
  const seo = {
    ...destination?.seo,
    metaTitle: `${
      destination?.seo?.metaTitle ??
      `${destination?.destination_title} Travel & Experiences`
    }`,
    canonicalURL:
      site +
      "/destinations/" +
      destination?.destination_details?.region?.region +
      "/" +
      destination?.slug,
  };

  const currencyContext = useContext(CurrencyContext);
  const sourceCurrency = currencyContext.currency.code.toUpperCase();

  const targetCurrency =
    destination?.key_facts?.sub_item
      ?.find((fact) => fact?.sub_heading === "Currency")
      ?.sub_item_description?.match(/\(([^)]+)\)/m)?.[1] ?? null;

  const relatedExperiencesRef = useRef();
  const relatedStoriesRef = useRef();
  const travelGuidesRef = useRef();
  const foodGuidesRef = useRef();
  // const viatorCardsRef = useRef();

  const [countryDetail, setCountryDetail] = useState({
    capital: "",
  });

  const [weatherLoading, setWeatherLoading] = useState(false);
  const [destinationWeather, setDestinationWeather] = useState({});

  const filteredGuides = Array.isArray(travelGuides)
    ? travelGuides?.filter((guide) => {
        const guideData = guide;

        if (!guideData?.slug || !guideData?.seo?.metaTitle) {
          return false;
        }
        return true;
      })
    : [];

  const anchorTags = [
    {
      tag: "key-facts-section",
      text: "Facts",
      active: !!destination?.key_facts?.sub_item?.length,
    },
    {
      tag: "experiences-section",
      text: "Experiences",
      active: !!relatedExperiences.length,
    },
    {
      tag: "guides-section",
      text: "Travel Guides",
      active: !!filteredGuides.length,
    },
    {
      tag: "activities-section",
      text: "Things to Do",
      active:
        !!destination?.activities?.information?.text ||
        !!destination?.activities?.list,
    },
    {
      tag: "stories-section",
      text: "Stories",
      active: !!relatedStories.length,
    },

    {
      tag: "weather-section",
      text: "Weather",
      active: !!destination?.climate?.text,
    },
    {
      tag: "food-section",
      text: "Food",
      active: !!foodGuide,
    },
    // {
    //   tag: "entry-requirements-section",
    //   text: "Visas",
    //   active: !!covidInfo || !!destination?.entry_requirements?.text,
    // },
    {
      tag: "accommodation-section",
      text: "Accommodation",
      active: !!destination?.accommodation?.text,
    },
    {
      tag: "transportation-section",
      text: "Transportation",
      active: !!destination?.transportation?.text,
    },
    { tag: "money-section", text: "Money", active: !!destination?.money?.text },
    // {
    //   tag: "insurance-section",
    //   text: "Insurance",
    //   active: !!destination?.insurance?.text,
    // },
    // {
    //   tag: "mobile-section",
    //   text: "Mobile",
    //   active: !!destination?.mobile?.text,
    // },
    // {
    //   tag: "community-section",
    //   text: "Community",
    //   active:
    //     !!destination?.community &&
    //     (!!destination?.community?.information?.text ||
    //       !!destination?.links?.length),
    // },
  ];

  const [activeAccordions, setActiveAccordions] = useState([]);

  // const router = useRouter();
  const windowSize = useWindowSize();

  const slides = generateBlazeSlides({
    slides: destination?.hero_slider,
    type: "destination",
    ctaButton: false,
  });

  useEffect(() => {
    if (windowSize.width > 992) {
      setActiveAccordions(anchorTags);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setActiveAccordions, windowSize.width]);

  const handleAccordionItemToggle = (id) => {
    setActiveAccordions((previous) => {
      if (previous.find((item) => item.tag === id)) {
        const next = previous.filter((accordion) => accordion.tag !== id);

        return [...next];
      }
      const tag = anchorTags.find((tag) => tag.tag === id);
      return [...previous, tag];
    });
  };

  const accordionItemProps = useMemo(() => {
    return {
      isPageSection: true,
      // startOpen: windowSize.width > 992 ? true : false,
      startOpen: true,
      classNames: ["scroll-margin-top-150"],
      onToggle: handleAccordionItemToggle,
      // titleFontSize: "28px",
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowSize.width]);

  const handleScrollNavClick = (event, tag) => {
    if (!!activeAccordions.find((accordion) => accordion.tag === tag.tag)) {
      return;
    }
    handleAccordionItemToggle(tag.tag);
  };

  useEffect(() => {
    if (!destination?.key_facts) return;

    async function fetchData() {
      const weatherCityCode =
        destination?.destination_details?.weather_city_code;

      try {
        setWeatherLoading(true);

        const capitalData = destination?.key_facts?.sub_item?.find(
          (v) => v.sub_heading === "Capital"
        )?.sub_item_description;
        const index = capitalData.indexOf("(");
        const capitalCity =
          index == -1 ? capitalData : capitalData.slice(0, index).trim();
        setCountryDetail({ capital: capitalCity });

        if (capitalCity && weatherCityCode) {
          let destWeather;
          const weatherRes1 = await fetch(
            `https://api.openweathermap.org/data/2.5/weather?q=${capitalCity},${weatherCityCode}&appid=051a797b4bd40bd79c1dc781988802eb`
          );
          const weatherData1 = await weatherRes1.json();

          if (weatherRes1.status !== 404) {
            destWeather = await weatherData1;
          } else {
            const weatherRes2 = await fetch(
              `https://api.openweathermap.org/data/2.5/weather?q=${weatherCityCode}&appid=051a797b4bd40bd79c1dc781988802eb`
            );
            const weatherData2 = await weatherRes2.json();

            destWeather = await weatherData2;
          }
          // const weatherRes1 = await fetch(
          //   `${site}/api/external/open-weather-map`,
          //   // `http://localhost:3001/api/external/open-weather-map`,
          //   {
          //     method: "POST",
          //     headers: {
          //       "Content-Type": "application/json",
          //     },
          //     body: JSON.stringify({
          //       url: `https://api.openweathermap.org/data/2.5/weather?q=${capitalCity},${weatherCityCode}`,
          //     }),
          //   }
          // );

          // const weatherData1 = await weatherRes1.json();

          // if (weatherRes1.status !== 404) {
          //   destWeather = await weatherData1;
          // } else {
          //   const weatherRes2 = await fetch(
          //     `${site}/api/external/open-weather-map`,
          //     {
          //       method: "POST",
          //       headers: {
          //         "Content-Type": "application/json",
          //       },

          //       body: JSON.stringify({
          //         url: `https://api.openweathermap.org/data/2.5/weather?q=${weatherCityCode}`,
          //       }),
          //     }
          //   );

          //   const weatherData2 = await weatherRes2.json();

          //   destWeather = await weatherData2;
          // }

          setWeatherLoading(false);

          setDestinationWeather(destWeather);
        }
      } catch (error) {
        console.error(error);
        setWeatherLoading(false);
        setDestinationWeather({});
      }
    }

    fetchData();
  }, [
    destination?.destination_details?.weather_city_code,
    destination?.key_facts,
  ]);

  // if (redirect) {
  //   return <></>;
  // }

  if (!destination) {
    return <></>;
  }

  return (
    <Layout seo={seo} layoutData={layoutData}>
      <div className={`${styles.hero} hero-container`}>
        <MainSlider sideNav={true}>{[...slides]}</MainSlider>
      </div>
      <div className={`${styles.destinationWrapper}`} id="mainContent">
        <Intro
          destination={destination}
          countryDetail={countryDetail}
          destinationWeather={destinationWeather}
          weatherLoading={weatherLoading}
        />
        <div className={`variable-container ${styles.accordionContainer}`}>
          <ScrollNav
            anchorTags={anchorTags}
            style="miniButtons"
            onClick={handleScrollNavClick}
          />

          <Accordion>
            {destination?.key_facts?.sub_item?.length && (
              <AccordionItem
                title="Key facts"
                icon="/assets/img/icons/info.svg"
                id="key-facts-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "key-facts-section"
                  )
                }
                {...accordionItemProps}
              >
                <KeyFacts
                  destination={destination}
                  experiences={relatedExperiences}
                />
              </AccordionItem>
            )}
            {!!relatedExperiences.length && (
              <AccordionItem
                title="Experiences"
                icon="/assets/img/icons/destination.svg"
                id="experiences-section"
                scrollElementRef={relatedExperiencesRef}
                scrollButtons={false}
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "experiences-section"
                  )
                }
                {...accordionItemProps}
              >
                <div ref={relatedExperiencesRef}>
                  <RelatedExperiences
                    experiences={relatedExperiences}
                    sideScroll="all"
                    sideScrollButtons={true}
                    cardRowRef={relatedExperiencesRef}
                  />
                </div>
              </AccordionItem>
            )}
            {!!filteredGuides?.length && (
              <AccordionItem
                title="Travel Guides"
                icon="/assets/img/icons/destination.svg"
                id="guides-section"
                scrollElementRef={travelGuidesRef}
                scrollButtons={false}
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "guides-section"
                  )
                }
                {...accordionItemProps}
              >
                <div ref={travelGuidesRef}>
                  <CardRow
                    cards={travelGuides.map((guide) => {
                      return <TravelGuideCard guide={guide} key={guide?.id} />;
                    })}
                    seeAll={false}
                    sideScrollButtons={true}
                    sideScroll="all"
                  ></CardRow>
                </div>
              </AccordionItem>
            )}

            {(!!destination?.activities?.information?.text ||
              !!destination?.activities?.list) && (
              <AccordionItem
                title="Things to Do"
                icon={<GiTreasureMap size={30} />}
                id="activities-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "activities-section"
                  )
                }
                {...accordionItemProps}
              >
                <ActivitiesSection
                  destinationSlug={destination.slug}
                  activities={destination?.activities?.list}
                />
              </AccordionItem>
            )}
            {!!relatedStories.length && (
              <AccordionItem
                title="Stories"
                icon="/assets/img/icons/book.svg"
                id="stories-section"
                scrollElementRef={relatedStoriesRef}
                scrollButtons={false}
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "stories-section"
                  )
                }
                {...accordionItemProps}
              >
                <div ref={relatedStoriesRef}>
                  <RelatedStories
                    stories={relatedStories}
                    sideScroll="all"
                    sideScrollButtons={true}
                    cardRowRef={relatedStoriesRef}
                  />
                </div>
              </AccordionItem>
            )}
            {!!destination?.climate?.text && (
              <AccordionItem
                title="Weather"
                icon={<WiDayCloudyGusts size={30} />}
                id="weather-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "weather-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.climate}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("weather")
                    )
                  }
                  column1ChildrenBefore={
                    windowSize.width < 992 ? (
                      <BasicWeatherWidget
                        destination={destination}
                        countryDetail={countryDetail}
                        loading={weatherLoading}
                        destinationWeather={destinationWeather}
                      />
                    ) : (
                      ""
                    )
                  }
                  column2ChildrenBefore={
                    windowSize.width > 992 ? (
                      <BasicWeatherWidget
                        destination={destination}
                        countryDetail={countryDetail}
                        loading={weatherLoading}
                        destinationWeather={destinationWeather}
                      />
                    ) : (
                      ""
                    )
                  }
                  icon={null}
                />
              </AccordionItem>
            )}
            {!!foodGuide && (
              <AccordionItem
                title="Food"
                icon={<CiBowlNoodles size={30} />}
                id="food-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "food-section"
                  )
                }
                scrollElementRef={foodGuidesRef}
                scrollButtons={false}
                {...accordionItemProps}
              >
                <div ref={foodGuidesRef}>
                  <FoodGuideCards
                    foods={foodGuide?.food}
                    sideScrollButtons={true}
                    cardRowRef={foodGuidesRef}
                  />
                </div>
              </AccordionItem>
            )}
            {/* {(covidInfo || destination?.entry_requirements?.text) && (
              <AccordionItem
                title="Visas"
                icon={<FaPassport size={30} />}
                id="entry-requirements-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) =>
                      accordion.tag === "entry-requirements-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.entry_requirements}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("visas")
                    )
                  }
                  column2ChildrenBefore={
                    <EntryRequirements
                      covidInfo={covidInfo}
                      visaInfo={{ iVisa: iVisaInfo }}
                    />
                  }
                  icon={null}
                />
              </AccordionItem>
            )} */}
            {!!destination?.accommodation?.text && (
              <AccordionItem
                title="Accommodation"
                icon={<RiHotelFill size={30} />}
                id="accommodation-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "accommodation-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.accommodation}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("accommodation")
                    )
                  }
                  icon={null}
                />
              </AccordionItem>
            )}

            {!!destination?.transportation?.text && (
              <AccordionItem
                title="Transportation"
                icon={<MdOutlineTrain size={30} />}
                id="transportation-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "transportation-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.transportation}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("transportation")
                    )
                  }
                  icon={null}
                />
              </AccordionItem>
            )}
            {!!destination?.money?.text && (
              <AccordionItem
                title="Money"
                icon={<BiMoney size={30} />}
                id="money-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "money-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.money}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("money")
                    )
                  }
                  column2ChildrenBefore={
                    affiliates?.find(
                      (affiliate) => affiliate.name === "Wise"
                    ) && (
                      <CurrencyConverter
                        sourceCurrency={sourceCurrency}
                        targetCurrency={
                          targetCurrency
                            ? targetCurrency
                            : sourceCurrency === "USD"
                              ? "EUR"
                              : "USD"
                        }
                      />
                    )
                  }
                  icon={null}
                />
              </AccordionItem>
            )}

            {/* {!!destination?.insurance?.text && (
              <AccordionItem
                title="Insurance"
                icon={<RiHospitalFill size={30} />}
                id="insurance-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "insurance-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.insurance}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("insurance")
                    )
                  }
                  icon={null}
                />
              </AccordionItem>
            )}

            {!!destination?.mobile?.text && (
              <AccordionItem
                title="Mobile"
                icon={<MdSignalCellular3Bar size={30} />}
                id="mobile-section"
                isOpen={
                  !!activeAccordions.find(
                    (accordion) => accordion.tag === "mobile-section"
                  )
                }
                {...accordionItemProps}
              >
                <InformationSection
                  information={destination?.mobile}
                  affiliates={
                    !!affiliates?.length &&
                    affiliates?.filter((affiliate) =>
                      affiliate.categories
                        .map((category) => category.category.toLowerCase())
                        .includes("mobile")
                    )
                  }
                  icon={null}
                />
              </AccordionItem>
            )}
            {!!destination?.community &&
              (!!destination?.community?.information?.text ||
                !!destination?.links?.length) && (
                <AccordionItem
                  title="Community"
                  icon={<MdPeopleAlt size={30} />}
                  id="community-section"
                  isOpen={
                    !!activeAccordions.find(
                      (accordion) => accordion.tag === "community-section"
                    )
                  }
                  {...accordionItemProps}
                >
                  <InformationSection
                    information={destination?.community?.information}
                    linkSections={destination?.community?.links}
                    affiliates={
                      !!affiliates?.length &&
                      affiliates?.filter((affiliate) =>
                        affiliate.categories
                          .map((category) => category.category.toLowerCase())
                          .includes("community")
                      )
                    }
                    icon={null}
                  />
                </AccordionItem>
              )} */}
          </Accordion>
        </div>
      </div>
    </Layout>
  );
};

export default Country;

export async function getStaticProps(context) {
  const destinationSlug = context.params.destinationSlug.replace(/&.*/gm, "");

  const destinationResponse = await fetchDestination(destinationSlug);

  const destination = await processDestinationData(
    destinationResponse.destination,
    {
      type: "full",
    }
  );

  // const mapDestinations = await fetchMapDestinations();

  const relatedExperiences = await destinationResponse.relatedExperiences.map(
    (experience) => {
      return processExperienceData(experience, { type: "basic" });
    }
  );

  const relatedStories = await destinationResponse.relatedStories.map(
    (story) => {
      return processStoryData(story, { type: "basic" });
    }
  );

  const destinationAffiliates = await fetchAffiliatesByDestination(
    destinationSlug,
    destination?.destination_details?.region?.region
  );

  const travelGuides = await fetchTravelGuidesByDestination({
    slug: destinationSlug,
    limit: 6,
  });

  const foodGuide = await destinationResponse?.relatedFoodGuide;

  let slides = [];

  for await (let slide of destination?.hero_slider) {
    if (slide?.video?.url) {
      const youTubeData = await fetchYouTubeData(slide.video);

      if (!youTubeData) {
        continue;
      }

      const newSlide = { ...slide, video: { ...slide.video, youTubeData } };
      slides.push(newSlide);
    } else {
      slides.push(slide);
    }
  }

  const layoutData = await fetchLayoutDataServer();

  const covidCountryInfo = covidInfo.find(
    (country) => country.name === destination?.destination_title
  );

  return {
    props: {
      relatedExperiences: relatedExperiences ?? [],
      relatedStories: relatedStories ?? [],
      destination: { ...destination, hero_slider: slides },
      affiliates: destinationAffiliates ?? [],
      mapDestinations: [],
      travelGuides: travelGuides ?? [],
      foodGuide: foodGuide ?? [],
      // iVisaInfo: iVisaData,
      layoutData: layoutData,
      covidInfo: covidCountryInfo ?? null,
    },
    revalidate: 86400,
  };
}

export async function getStaticPaths() {
  const strapiApolloClient = graphQlClient();

  let destinationsResponse = await strapiApolloClient.query({
    query: gql`
      query DestinationsPathQuery {
        destinations(pagination: { start: 0, limit: 300 }) {
          data {
            id
            attributes {
              destination_title
              slug
              destination_details {
                region {
                  data {
                    attributes {
                      region
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  });

  // Filter out incomplete data
  const filteredPaths = await destinationsResponse.data.destinations.filter(
    (pathObject) => {
      const path = pathObject.data.attributes;

      if (
        path?.slug &&
        path?.destination_details?.region?.data?.attributes?.region
      ) {
        return true;
      }
    }
  );

  const paths = await filteredPaths.map((pathObject) => {
    const path = pathObject.data.attributes;
    return {
      params: {
        slug: path?.destination_details?.region?.data?.attributes?.region.toString(),
        destinationSlug: path.slug.toString(),
      },
    };
  });

  return {
    paths,
    // paths: [{ slug: "asia", destinationSlug: "nepal" }],
    fallback: false,
  };
}
